import { apiClient } from './api/client';

export async function getTodayMeeting() {
  return apiClient.get('/api/meetings/today');
}

export async function getActiveHostSession() {
  return apiClient.get('/api/meetings/host-session/active');
}

export async function startHostSession() {
  return apiClient.post('/api/meetings/host-session/start', {});
}

export async function revokeHostSession() {
  return apiClient.post('/api/meetings/host-session/revoke', {});
}

// QR onboarding flow (public — no auth)
export async function identifyForMeeting({ email, qrToken }) {
  return apiClient.post('/api/meetings/identify', { email, qrToken }, { skipAuth: true });
}

export async function requestMeetingMagicLink({ lookup, qrToken }) {
  return apiClient.post('/api/meetings/magic-link/request', { lookup, qrToken }, { skipAuth: true });
}

export async function confirmMeetingMagicLink({ token }) {
  return apiClient.post('/api/meetings/magic-link/confirm', { token }, { skipAuth: true });
}

export async function activateMember({ email, password, confirmPassword, qrToken }) {
  return apiClient.post('/api/meetings/activate', { email, password, confirmPassword, qrToken }, { skipAuth: true });
}

export async function registerGuest(data) {
  return apiClient.post('/api/meetings/register-guest', data, { skipAuth: true });
}

// Fixed-QR support: the schedule Leadership can cancel from, and the switch
// that closes a morning now that there is no weekly token to withhold.
export async function getMeetingSchedule() {
  return apiClient.get('/api/meetings/schedule');
}

export async function cancelMeeting(meetingId, options = {}) {
  return apiClient.post(`/api/meetings/${meetingId}/cancel`, {
    reason: options.reason ?? null,
    rollForward: options.rollForward !== false,
    rollForwardToMeetingId: options.rollForwardToMeetingId ?? null,
  });
}

// Move one guest's registration to another morning, from the Leadership page.
export async function rescheduleGuestInvite(inviteId, meetingId) {
  return apiClient.post(`/api/meetings/guest-invites/${inviteId}/reschedule`, { meetingId });
}

// Guest self-service, reached from the cancellation email.
export async function getGuestRescheduleOptions(token) {
  return apiClient.get('/api/meetings/guest-reschedule', { params: { token }, skipAuth: true });
}

export async function chooseGuestRescheduleMeeting(token, meetingId) {
  return apiClient.post('/api/meetings/guest-reschedule', { meetingId }, { params: { token }, skipAuth: true });
}

export async function reinstateMeeting(meetingId) {
  return apiClient.post(`/api/meetings/${meetingId}/reinstate`, {});
}
